import { Components, Theme } from '@mui/material';

export const MuiTooltip: Components<Omit<Theme, 'components'>>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      fontSize: theme.typography.fontSize,
    }),
  },
};
